/* eslint-disable max-len */
export const dictionary = {
  Loading: 'Cargando',
  'Policy and Privacy Terms': 'Términos de Política y Privacidad',
  'Terms of Use': 'Términos de Uso',
  'Change Game': 'Cambiar el juego',
  PrivacyPolicy: 'Política de Privacidad',
  'Game Journey': 'Jornada del juego',
  'I agree with': 'Estoy de acuerdo com el',
  "Engagers Game's": 'de Engagers Game',
  'Enter here': 'Inserta aquí',
  'Register below': 'Registra a continuación',
  'Register here': 'Registra aquí',
  'Click here': 'Haz clic aquí',
  Close: 'Cerrar',
  'Enter your password to continue': 'Introduzca la contraseña para continuar',
  'Wrong password': 'Contraseña incorrecta',
  'Start the mission here': 'Comenzar la misión aquí',
  'Follow the score here': 'Sigua la puntuación aquí',
  'The time will appear centered when starting the mission': 'Cuando comiences la misión, el tiempo aparecerá centrado',
  'Enlarge the image if necessary': 'Agranda la imagen si lo necesitas',
  'Send photo': 'Enviar foto',
  'Take photo': 'Tomar foto',
  'Drag or paste your photo here': 'Arrastra o pega tu foto aquí',
  'Choose photo': 'Elegir foto',
  'Photo caption': 'Pie de foto',
  'Select below': 'Selecciona a continuación',
  'alternative(s)': 'alternativa(s)',
  Blocked: 'Bloqueada',
  Done: 'Realizada',
  'See missions': 'Ver misiones',
  Gallery: 'Galería de imágenes',
  Instructions: 'Instrucciones',
  Points: 'Puntos',
  'Recovery game': 'Recuperar juego',
  'Audio: on/off': 'Sonido: encendido/apagado',
  "Your browser don't support HTML5": 'Su navegador no es compatible com HTML5',
  "Couldn't load instructions": 'No se pudieron cargar las instrucciones',
  Team: 'Equipo',
  Mission: 'Misión',
  PhotoMission: 'Misión de foto',
  PhotoMissionInstructionOne: 'Haga clic en el botón de la cámara para cargar la imagen deseada.',
  PhotoMissionInstructionTwo: 'Si lo deseas, escriba un pie de foto em el cuadro justo debajo de la imagen cargada.',
  PhotoMissionInstructionThree: 'Haz clic em el botón de la esquina inferior derecha para completar la misión.',
  PhotoMissionInstructionDesktop: 'Arrastre imágenes o pegue capturas de pantalla en la entrada más grande.',
  TeamName: 'Nombre del equipo',
  OpenAnswer: 'Respuesta abierta',
  OpenAnswerInstructionOne: 'Ingresa tu respuesta en el cuadro que dice "Escriba aquí ..." y luego haga clic en el botón en la esquina inferior derecha para enviar tu respuesta.',
  ConnectDots: 'Conecta los puntos',
  ConnectDotsInstructionOne: 'Selecciona com un clic la opción de la columna (A) y luego selecciona la opción a la que se conecta em la columna (B).',
  SimpleText: 'Texto simple',
  SimpleTextInstructionOne: 'Después de leer la pantalla, haga clic em el botón em la esquina inferior derecha para continuar.',
  MultipleChoice: 'Opción múltiple',
  MultipleChoiceInstructionOne: 'Haga clic em la flecha em la esquina derecha de la barra para ver el texto completo de la alternativa, cuando haya.',
  MultipleChoiceInstructionTwo: 'Haga clic em la parte superior de la barra com la alternativa que desea seleccionar.',
  MultipleChoiceInstructionThree: 'Para enviar la respuesta, haga clic em el botón em la esquina inferior derecha.',

  Welcome: '¡Bienvenido(a)!',
  'Login to access the game': 'Inicia tu sesión para acceder al juego.',
  'Sign in with Google': 'Iniciar sesión con Google',
  Password: 'Contraseña',
  'Enter with your E-mail': 'Ingrese su correo electrónico',
  'Enter with the password': 'Ingrese su contraseña',
  Access: 'Acceder',
  'Forgot your password?': 'He olvidado mi contraseña',
  'Need help?': 'Tengo dudas',
  'Required field': 'Campo obligatorio',
  'E-mail is required': 'Se requiere correo electrónico',
  'E-mail is invalid': 'El correo electrónico no es válido',
  'Password is required': 'Se requiere contraseña',
  'Password must have 8 characters at least': 'La contraseña debe tener al menos 8 caracteres',
  'Password must have 1 number at least': 'La contraseña debe tener al menos 1 numero',
  'Password must have 1 lowercase letter at least': 'La contraseña debe tener al menos una letra minúscula',
  'Password must have 1 uppercase letter at least': 'La contraseña debe tener al menos una letra mayúscula',
  'Password must have 1 special character at least': 'La contraseña debe tener al menos un carácter especial',
  'New Password': 'Nueva contraseña',
  'Changing...': 'Cambiando...',
  Change: 'Cambiar',
  'Change your name': 'Cambiar tu nombre',
  'Change your password': 'Cambiar tu contraseña',
  'Tell us what would you like to be called?': '¿Cuéntanos cómo te gustaría que te llamaran? Este nombre se vinculará a sus respuestas de Feed.',
  'Your name': 'Tu nombre',
  "Your game hasn't started yet.": 'Tu juego aún no ha comenzado.',
  'Your game is now finished.': 'Tu juego ya ha sido finalizado.',
  'There is no game for you yet.': 'Todavía no hay juego para ti.',
  Finish: 'Todo listo con el juego',
  'Start playing': 'Empezar a jugar',
  'As this is your first access, you must change your password for your best security!': 'Como este es tu primer acceso, ¡debes cambiar tu contraseña para tener más seguridad!',
  PasswordRules: 'Tu contraseña debe tener al menos <span>8 caracteres</span> con al menos <span>1 letra mayúscula</span>, <span>1 letra minúscula</span>, <span>1 número</span> y <span>1 carácter especial</span>',
  'No missions until now': 'Sin misiones hasta ahora.',
  'Good! You finished all available missions!': '¡Bien! ¡Has cumplido todas las misiones disponibles!',
  'These are your missions for today:': 'Esas son tus misiones de hoy:',
  'Finished missions': 'Misiones terminadas',
  'Allowed missions': 'Misiones permitidas',
  Home: 'Inicio',
  More: 'Más',
  'Change Password': 'Cambiar contraseña',
  'Current Password': 'Contraseña actual',
  'Confirm New Password': 'Confirmar nueva contraseña',
  Save: 'Guardar',
  Saving: 'Guardando',
  'Password updated successfully!': 'Contraseña cambiada com éxito!',
  'Sign Out': 'Salir',
  'Do you really want to sign out?': '¿Realmente quieres salir?',
  Yes: 'Si',
  No: 'No',
  'Recovery Password': 'Recuperar contraseña',
  Code: 'Código',
  'Enter the code': 'Introduzca el código',
  'Send code': 'Enviar código',
  Sending: 'Enviando',
  'Enter the new password': 'Introducir la nueva contraseña',
  'Confirm the new password': 'Confirmar nueva contraseña',
  'Password recovered successfully!': '¡Contraseña recuperada com éxito!',
  'Try again': 'Vuelva a intentar',
  'Send us a message': 'Envíanos un mensaje',
  Name: 'Nombre',
  Game: 'Juego',
  Message: 'Mensaje',
  Send: 'Enviar',
  'Your message was sent. We will reply to you by e-mail shortly.': 'Su mensaje ha sido enviado. Pronto le responderemos por correo electrónico.',
  Document: 'Documento',
  ForgotPasswordSuccess: 'Los datos de recuperación han sido enviados a su correo electrónico. Verifique e inicie sesión.',
  'Go to Login': 'Ir a Iniciar sesión',

  AlertSendAnswer: 'Error al enviar su respuesta, inténtelo de nuevo más tarde.',

  ValidateMinName: 'Al menos 2 caracteres',
  ValidatePasswordNotEquals: 'Las contraseñas no son similares',
  ValidateOnlyNumbers: 'Sólo números',

  ERROR_ACCESS_DENIED: 'Acesso denegado.',
  ERROR_UNEXPECTED: 'Algo salió mal.',
  ERROR_NO_AUTHORIZATION: 'Sin autorización.',
  ERROR_DATA_NOT_FOUND: 'Datos no encontrados',
  INFO_DATA_NOT_FOUND: 'Acceder al Juego de nuevo o póngase en contacto con el soporte.',
  "You don't have permission to access this page.": 'Usted no tiene permiso para acceder a esta página.',

  'Create Account': 'Crea tu cuenta',
  'create account': 'crea tu cuenta',
  'Signup to access the game': 'Regístrate para acceder al juego',
  'signup to access the game': 'regístrate para acceder al juego',
  'to get start now': 'para empezar',
  'game code': 'código del juego',
  'First access ?': '¿primer acceso?',
  Register: 'crea tu login',
  'Already have an account?': '¿ya has creado tu login?',
  'game code should have 6 characters at least': 'el código del juego tiene 6 caracteres',
  'confirm the password': 'confirma tu contraseña',
  'full name is required': 'ingresa tu nombre completo',
  'your credentials': 'tus credenciales',
  'save or print it to login': 'guardar o tomar una captura de pantalla',
  team: 'equipo',
  'Invalid reCaptcha': 'reCaptcha no válido',
  'Game not found': 'juego no encontrado',
  'Players list not found': 'ninguna lista de jugadores encontrada',
  'Player not found': 'jugador no encontrado',
  'Team not found': 'equipo no encontrado',
  password: 'contraseña',
  access: 'acceder',
  'Welcome Back !!!': '¡¡¡Bienvenido(a)!!!',
  'welcome back !!!': '¡¡¡bienvenido(a)!!!',
  'login to access the game': 'iniciar sesión para acceder al juego',
  'or sign in to your account': 'o haz tu login',
  'password confirmation': 'confirmación de la contraseña',
  'enter with your e-mail': 'inserta tu correo electrónico',
  'enter with the password': 'inserta tu contraseña',
  'full name': 'nombre completo',
  'game code is required': 'informa el código del juego',
  'Game code': 'Código del juego',
  'Or Login': 'O haz tu login',
  'Full name is required': 'Inserta tu nombre completo.',
  'Full name': 'Nombre completo.',
  'this is your team': 'este es tu equipo',
  'this is your login': 'este es tu login',
  'this is your password': 'esta es tu contraseña',
  return: 'regressar',
  Support: 'Soporte',
  'We would like your Full name, please': 'Ingresa tu nombre completo',
  'This code was sent along with game link': 'Este código fue enviado junto con el enlace del juego',
  nickname: 'Crea tu acceso',
  'Create your password': 'Crea tu contraseña',
  'Nickname is required': 'Acceso es obligatorio',
  'TIP: TAKE A SCREENSHOT AND USE THEM WHENEVER YOU NEED TO ACCESS THE GAME AGAIN': 'Consejo tome una impresión y téngala a mano cuando sea necesario',
  'I need help !!!': 'Necesito ayuda',
  'Create your nickname': 'Crea tu acceso',
  'Passwords confirmation is required': 'Confirma tu contraseña para continuar',
  'Can you help us identify you correctly?': '¿Nos ayudas a identificarte correctamente? ',
  'Select the option that corresponds to your registration': 'Seleccione la opción que corresponda a su registro.',
  'Hi, do you already create an account?': 'Olá, ¿ya has creado tu cuenta?',
  'Select a game': 'Seleccione un juego',
  'If yes, click on the button below to login': 'Si, haz clic en el botón debajo para iniciar sesión',
  'If not, click on the button below to register': 'Si, haz clic en el botón debajo para registrarte',
  'Return to login': 'Regresar a iniciar sesión',
  'Do you save your credentials?': '¿Guardas tus credenciales?',
  'Remember, your login / email to access is:': 'Recuerda, tu login / correo electrónico para acceder es: ',
  'Enter the login you created for this game': ' Introduce tu login creado para este juego',
  'Please fill in the fields below': 'Por favor, rellena los campos debajo',
  'Ooops, I think you put the wrong password': 'Ooops, creo que ingresaste la contraseña incorrecta',
  'Please, try again': 'Por favor, inténtalo de nuevo',
  'Ooops, I think you put the wrong password again': 'Ooops, creo que ingresaste la contraseña incorrecta nuevamente',
  'If you need help, please contact us': 'Si necesitas ayuda, por favor contáctanos',
  'Password attempts exceeded': ' Intentos de contraseña excedidos',
  'Check your Login': ' Comprobar tu Login',
  'Check your password': 'Comprobar tu contraseña',
  PASS_REQUIREMENTS: 'Su contraseña debe tener al menos: 8 caracteres, incluyendo 1 número, 1 letra mayúscula y 1 carácter especial.',
  NotAuthorizedException: 'No autorizado: Contraseña incorrecta',
  'Incorrect username or password.': 'No autorizado: Contraseña incorrecta',
  UserNotFoundException: 'Este usuario no existe',
  'User does not exist.': 'Este usuario no existe',
  UserNotConfirmedException: 'El usuario aún no ha sido confirmado',
  'User is not confirmed.': 'El usuario aún no ha sido confirmado',
  PasswordResetRequiredException: 'Se requiere restablecer la contraseña: es necesario restablecer la contraseña del usuario',
  'Password reset required for the user.': 'Se requiere restablecer la contraseña: es necesario restablecer la contraseña del usuario',
  InvalidPasswordException: 'Contraseña no válida: la contraseña no cumple con la política de contraseña',
  'Password does not conform to policy:...': 'Contraseña no válida: la contraseña no cumple con la política de contraseña',
  CodeMismatchException: 'Código de verificación no válido: se proporcionó un código de verificación incorrecto',
  'Invalid verification code provided...': 'Código de verificación no válido: se proporcionó un código de verificación incorrecto',
  ExpiredCodeException: 'Código expirado: se proporcionó un código no válido, por favor solicite uno nuevo',
  'Invalid code provided, please request a new one.': 'Código expirado: se proporcionó un código no válido, por favor solicite uno nuevo',
  LimitExceededException: 'Límite de intentos superado, intente nuevamente después de algún tiempo',
  'Attempt limit exceeded, please try after some time.': 'Límite de intentos superado, intente nuevamente después de algún tiempo',
  InternalErrorException: 'Se produjo un error interno',
  'Internal error occurred.': 'Se produjo un error interno',
  ServiceUnavailableException: 'Servicio no disponible: el servicio está temporalmente no disponible, inténtelo nuevamente más tarde',
  'Service is temporarily unavailable, please try again later.': 'Servicio no disponible: el servicio está temporalmente no disponible, inténtelo nuevamente más tarde',
  'Please, signup below': 'Por favor, regístrese a continuación',
  'Click to select this item': 'Haga clic para seleccionar',
  Undo: 'Deshacer',
  APPROVAL_MODE_INSTRUCTIONS: 'Hola, ¡recibiste este juego para aprobar!',
  Today: 'Hoy',
  Comments: 'Comentarios',
  'Enter here your improvement suggestion or comment.': 'Digite aquí una sugerencia de mejora o comentario.',
  'Reply or add a comment...': 'Responda o agregue un comentario...',
  'Enter your name please': 'Ingrese su nombre por favor',
  Now: 'Ahora',
  'Leave a comment...': 'Deja un comentario...',
  Previous: 'Regresar',
  'You are in approval mode': 'O juego está en modo de aprobación',
  'Please, leave a review or approve this mission to go ahead :)': 'Por favor, deja un comentario o aprove esta missão para continuar.',
  'It is impossible to revert to the initial missions': 'Es imposible regresar a las misiones iniciales',
  ATTEMPTS_TRIGGER_NAME: 'Desencadenador de Intentos',
  CORRECT_ANSWER_TRIGGER_NAME: 'Desencadenador de Respuesta Correcta',
  TIMEOUT_TRIGGER_NAME: 'Desencadenador de Tiempo Agotado',
  TRANSITION_TRIGGER_NAME: 'Desencadenador de Transición',
  WRONG_ANSWER_TRIGGER_NAME: 'Desencadenador de Respuesta Incorrecta',
  DEFAULT_TRIGGER_NAME: 'Desencadenador Predeterminado',
  'Review the following screens by commenting or approving each mission.': 'Revise las siguientes pantallas comentando o aprobando cada misión.',
  'Enter your name:': 'Ingrese su nombre:',
  Start: 'Comenzar',
  'Leave a review by clicking here.': 'Deja una reseña haciendo clic aquí.',
  'Approve this mission without a review by clicking here.': 'Aprueba esta misión sin revisión haciendo clic aquí.',
  pending: 'Pendiente',
  resolved: 'Resuelto',
  approved: 'Aprobado',
  'We will send you a confirmation e-mail.': 'Le enviaremos un correo electrónico de confirmación.',
  'Account activation': 'Activación de la cuenta',
  'We were unable to confirm your account, please contact support.': 'No hemos podido confirmar su cuenta, póngase en contacto con el servicio de asistencia.',
  'Hello, you are invited to join this game': 'Hola, te has invitado a unirte a este juego',
  'Your Team': 'Tu equipo',
  'Click here to login': 'Haga clic aquí para iniciar sesión',
  'By checking this box, you are agreeing to our terms of service': 'Al hacer clic en la casilla, acepta nuestros Términos de Servicio',
  'Click here to read the Use Terms and Conditions': 'Haga clic aquí para leer los Términos de Uso y las Condiciones de Servicio',
  'You account has been activated': 'Su cuenta ha sido activada',
  'To update your actvation token, insert your e-mail:': 'Para actualizar el token de activación, ingrese su correo electrónico:',
  'User not found': 'Usuario no encontrado',
  Return: 'Regressar',
  'Points will be awarded after content verification.': 'Se otorgarán puntos después de la verificación del contenido.',
  'Record audio': 'Grabar audio',
  'Audio description': 'Descripción del audio',
  'Record audio time': 'Grabar audio por tiempo',
  'Drag or paste your audio file here': 'Arrastra o pega tu archivo de audio aquí'
}
